// @flow

// Constants
import {
  GROWER,
} from 'fc-model-assets'

// Selectors
import makeAssetsOfCategory from './composers/makeAssetsOfCategory'

// Exports
export default makeAssetsOfCategory({
  category: GROWER,
})
